import $ from 'jquery';

window.$ = window.jQuery = $;
window.$ = window.jQuery = $.noConflict();

let byDrop;
let isOutside = true;

export class CustomDropdown {
    constructor() {

        $(document).off('click');

        $('body').on('click', '.js-custom-dropdown', function (event) {
            byDrop = $(this);
            $(this).toggleClass('isActive');
            $(this).blur();
        });

        $(document).click(function (eventDoc) {

            if (!byDrop) {
                isOutside = true;
            }

            if (byDrop) {
                $('.js-custom-dropdown.isActive').each((index, el) => {
                    if (!($(el).is(byDrop))) {
                        $(el).removeClass('isActive');
                    }
                });

                byDrop = null;
                isOutside = false;
            }

            if (isOutside) {
                $('.js-custom-dropdown.isActive').each((index, el) => {
                    $(el).removeClass('isActive');
                });
            }
        });
    }
}